<div class="onboarding-header">
  <div class="onboarding-header-title">
    <tidy-text [title]="'Video Tutorial'" />
  </div>
  <div>
    <button
      mat-button
      fill="clear"
      color="primary"
      style="min-width: 0px"
      (click)="closeModal()">
      <tidy-text [body]="'X'" />
    </button>
  </div>
</div>
<tidy-divider />

<div class="advanced-setup-content">
  @if (videoUrl) {
    <iframe
      frameborder="0"
      class="video-tutorial-iframe"
      [src]="videoUrl"
    allow="autoplay"></iframe>
  }
</div>
